import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const year = get(state, 'mostCreativePeople.year');
  const imgPresets =
    'https://assets.fastcompany.com/image/upload/w_530,q_auto,f_auto,fl_lossy';
  const posterImgs = {
    2017: `${imgPresets}/v1494843167/MCPwith100and2017forSocial.jpg`,
    2016: `${imgPresets}/v1495030888/MCP100-2016Logo-SHARE.png`,
    2015: `${imgPresets}/v1495030888/MCP100-2015Logo-SHARE.png`,
    2014: `${imgPresets}/v1495030888/MCP100-2014Logo-SHARE.png`,
    fallback: `${imgPresets}/v1495030888/MCP-Logo-default-SHARE.png`
  };

  return baseSeoUtil({
    site,
    siteConf,
    title: `Most Creative People in Business ${year} | Fast Company`,
    url: `https://www.fastcompany.com/most-creative-people/${year}`,
    description: `Meet ${year}'s most inspiring leaders in the Fast Company community`,
    image: posterImgs[year] || posterImgs.fallback,
    articleSection: 'Most Creative People'
  });
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/most_creative_people_seo_util.js